import { EntityApi } from "../../../Shared/Constants/api";

import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { getEntityUpdatenObject } from "../Data/EntitiyWrappers";

export const updateEntityApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${EntityApi}/${id}`,
      getEntityUpdatenObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
